import { Component, OnInit } from '@angular/core';
import {ICellRendererAngularComp} from 'ag-grid-angular';
import { AuthService } from 'src/app/services/auth.service';
import { GridService } from 'src/app/services/grid.service';
import { HttpService } from 'src/app/services/http.service';
import {environment} from '../../../../environments/environment';
import {InfoService} from '../../../services/info.service';
import {ICellRendererParams, RowNode} from 'ag-grid-community';
import {ToastService} from '../../../services/toast.service';

@Component({
  selector: 'app-confirmation-cell',
  templateUrl: './confirmation-cell.component.html',
  styleUrls: ['./confirmation-cell.component.scss']
})
export class ConfirmationCellComponent implements ICellRendererAngularComp {
  private params: any;
  public disabled: boolean = false;
  public disabledAll: boolean = false;
  public rowOnEdit: boolean = false;
  public user_name: string = '';
  public handleError: boolean = false;

  constructor(
    private httpService: HttpService,
    private gridService: GridService,
    private authService: AuthService,
    private infoService: InfoService,
    private toastService: ToastService,
  ) { }

  ngOnInit(): void {
    console.log('init');
    if (this.authService.currentUserValue.access.level === 3) {
      this.disabledAll = true;
    }
  }

  agInit(params: any): void {
    this.params = params;
    if (params.data?.history?.accepted_status === 4) {
      this.disabled = true;
    }
    if ((params.data?.handle === undefined || params.data?.handle?.length === 0) || (params.data?.sku === undefined || params.data?.sku?.length === 0)) {
      this.disabled = true;
      this.handleError = true;
    }

    if (this.params.data.locked && this.params.data.locked.user && (this.params.data.locked.user._id !== this.authService.currentUserValue._id)) {
      if (this.params.pinned) {
        this.user_name = this.params.data.locked?.user?.name;
        this.rowOnEdit = true;
      }
    }
    if (this.params.data.disableConfirmButton) {
      this.disabledAll = true;
    }
  }

  refresh(params: ICellRendererParams) {
    this.params = params;
    return true;
  }

  btnClickedHandler() {
    this.params.clicked(this.params.value);
  }

  yes() {
    const data = {
      ids: [this.params.data._id]
    };
    this.disabledAll = true;
    this.gridService.changesGridApi?.forEachNode((rowNode: RowNode) => {
      if (rowNode.data._id === this.params.data._id) {
        rowNode.data.disableConfirmButton = true;
        rowNode.setData(rowNode.data);
      }
    });
    this.httpService.post(environment.API_PATH + '/changes/confirm', data).subscribe(resp => {
      if (resp.error) {
        this.toastService.info(resp.error);
        setTimeout(() => {
          this.gridService.changesGridApi?.forEachNode((rowNode: RowNode) => {
            if (rowNode.data._id === this.params.data._id) {
              rowNode.data.disableConfirmButton = false;
              rowNode.setData(rowNode.data);
            }
          });
        }, 3000);
      } else {
        this.infoService.update();
        this.disabledAll = false;
      }
    });
  }

  no() {
    const data = {
      ids: [this.params.data._id]
    };
    this.disabledAll = true;
    this.gridService.changesGridApi?.forEachNode((rowNode: RowNode) => {
      if (rowNode.data._id === this.params.data._id) {
        rowNode.data.disableConfirmButton = true;
        rowNode.setData(rowNode.data);
      }
    });
    this.httpService.post(environment.API_PATH + '/changes/reject', data).subscribe(resp => {
      if (resp.error) {
        this.toastService.info(resp.error);
        setTimeout(() => {
          this.gridService.changesGridApi?.forEachNode((rowNode: RowNode) => {
            if (rowNode.data._id === this.params.data._id) {
              rowNode.data.disableConfirmButton = false;
              rowNode.setData(rowNode.data);
            }
          });
        }, 3000);
      } else {
        this.infoService.update();
        setTimeout(() => {
          this.disabled = false;
          this.disabledAll = false;
        }, 300);
      }
    });
  }
}
